import { render, staticRenderFns } from "./RListContent.vue?vue&type=template&id=62bbc045&scoped=true"
import script from "./RListContent.vue?vue&type=script&lang=js"
export * from "./RListContent.vue?vue&type=script&lang=js"
import style0 from "./RListContent.vue?vue&type=style&index=0&id=62bbc045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bbc045",
  null
  
)

export default component.exports